import { IMaskMixin } from "react-imask";
import FormControl from "react-bootstrap/FormControl";

export type Props = any;

export const MaskedFormControl = IMaskMixin(({ inputRef, ...props }: Props) => (
	<FormControl {...props} ref={inputRef} />
));
